import { render, staticRenderFns } from "./forgot-password-page.vue?vue&type=template&id=1d2ec478&scoped=true&"
import script from "./forgot-password-page.vue?vue&type=script&lang=js&"
export * from "./forgot-password-page.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password-page.vue?vue&type=style&index=0&id=1d2ec478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ec478",
  null
  
)

export default component.exports
import {QForm,QInput,QIcon,QBtn,QSpinnerIos} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QIcon,QBtn,QSpinnerIos})
